<template lang="pug">
  .product-container
    .product-header
      .product-title
        p {{ $t('Bid Agent') }}
        p {{ $t('搜索广告管理工具') }}
      .product-desc Bid Agent是一款专为中国市场设计的搜索引擎优化管理工具，支持5大搜索引擎。
      .product-desc Bid Agent平均为广告主提升18%的投放效果，同时平均提升47%的管理效率。
      .product-desc 目前已为阳狮广告、GroupM等知名4A公司提供服务与支持。
      el-button.product-link(
        @click="onApplyAccount"
      ) {{ $t('申请Demo账号') }}
      .product-img
        img(
          src="@/assets/bid_agent-1.png"
        )
    .product-content-container
      .product-content-item
        .product-content-desc
          .desc-title {{ $t('效果') }}
          .desc(style="margin-left: 0") {{ $t('Bid Agent系统帮助提升搜索广告效果。') }}
          .desc(style="margin-left: 0") {{ $t('使用后平均能为广告主提升18%的投放效果，折合增加20%的预算。') }}
        .product-content-desc
          .desc-subTitle
            img(
              src="@/assets/libra-icon.png"
            )
            span {{ $t('锁定排名') }}
          .desc {{ $t('锁定排名功能同时支持百度和360两大搜索引擎，通过抓取实况结果实时监测排名情况， 利用复歌独家算法在保证排名的同时优化出价，从而实现以最优价格取得目标排名。 “小时任务”和“一次性任务”可随意选择，满足不同优化需求。') }}
        .product-content-desc
          .desc-subTitle
            img(
              src="@/assets/libra-icon.png"
            )
            span {{ $t('反作弊') }}
          .desc {{ $t('由复歌科技与RTBAsia合作推出，依托于国内强大的IP识别系统，可有效识别并实时屏蔽非人类流量。 当系统监测到点击搜索广告的流量是虚假IP后， 会立刻将此IP加为搜索引擎黑名单，从而排除无效点击，有效保护账户安全，节省花销。') }}
        img(
          src="@/assets/bid_agent-2.png"
        )
      .product-content-item
        .product-content-desc
          .desc-title {{ $t('效率') }}
          .desc(style="margin-left: 0") {{ $t('Bid Agent系统帮助节省用户的优化操作时间。') }}
          .desc(style="margin-left: 0") {{ $t('使用后人均管理效率平均提升47%，每人可管理的账户数量增加一倍。') }}
        .product-content-desc
          .desc-subTitle
            img(
              src="@/assets/libra-icon.png"
            )
            span {{ $t('智能报告') }}
          .desc {{ $t('Bid Agent内设置日/周/月报模版。是由复歌团队分析了众多代理商/广告主报告模版后，提炼出的“精华模版”。 尤其适合同一品牌需要在多个搜索引擎上管理多个账号的大型广告主。同时还有自定义报告功能，支持选择不同的时间粒度和账户层级组合出近1,000种数据报告，为广告主大大减少工作量，提高效率。') }}
        img(
          src="@/assets/bid_agent-3.png"
          )
      .product-content-item
        .product-content-desc
          .desc-title {{ $t('洞察') }}
          .desc(style="margin-left: 0")
            p {{ $t('Bid Agent提供独一无二的洞察数据，相当于为每个广告主增加43个搜索推广专员。') }}
        .product-content-desc
          .desc-subTitle
            img(
              src="@/assets/libra-icon.png"
            )
            span {{ $t('竞品监测') }}
          .desc
            p {{ $t('竞争对手监测功能通过对广告进行监测分析，为广告主回答核心问题：') }}
            p {{ $t('自身品牌及主要竞品在搜索引擎上的搜索量对比。') }}
            p {{ $t('竞品购买了哪些关键词，表现如何，花了多少钱。') }}
            p {{ $t('全行业中哪个品牌在搜索广告上的综合表现最好，最热门的通用词是什么。') }}
        img(
          style="height: auto"
          src="@/assets/bid_agent-4.png"
        )
    section#clients-say
      div.clients-say__content
        img(
          alt="what our clients say"
          src="@/assets/clients-say-logo.png"
        )
        div
          ul.clients-say__case__content(style="height:240px")
            li(:class="{'active': activeIndex === 0}")
              p {{ $t('使用Bid Agent已经有超过两年的时间，软件的不断完善是有目共睹的，BA团队一直在坚持聆听客户的声音，并能快速响应，将我们的很多建议变成现实功能。通过BA的锁定排名功能，在很大程度上确保了关键词排名，自动报告功能节省了工作时间，提高了工作效率。其他功能，也是从业务出发而打造的，真正在乎用户体验。') }}
            li(:class="{'active': activeIndex === 1}")
              p {{ $t("Bid Agent是个强大的优化系统，能够集合各搜索引擎于一体，最大限度帮助客户节约成本，提高投入产出比，一站式解决搜索的全程优化。更能提供高逼格的可视化报告，定制专属于客户的模板。") }}
            li(:class="{'active': activeIndex === 2}")
              p {{ $t("使用BA 5年，BA帮助我们便捷管理跨搜索引擎的多个后台，并生成定制化报告，有效提升大体量账户投放效率；近几年随着平台功能进化，竞争对手监测的功能弥补了市场的空白，帮助我们洞察竞争对手市场动作；但复歌团队仍然不断挑战，2017年推出的反作弊功能，又一次走在了市场前列，规避投放中的问题流量，帮助广告主代理商进行更有效的投放。为此，衷心感谢多年来复歌的合作伙伴的努力和支持！") }}
          ul.clients-say__case__avators.f.f-sa
            li(
              :class="{'active_li': activeIndex === 0}"
              @mouseover="activeIndex = 0"
            )
              div
                img(
                  alt="avator"
                  src="@/assets/elvis-xu.jpg"
                )
              p
                | Elvis Xu
                br
                span
                  | Managing Director, Search/GroupM
            li(
              @mouseover="activeIndex = 1"
              :class="{'active_li': activeIndex === 1}"
            )
              div
                img(
                  alt="avator"
                  src="@/assets/wenya-li.jpg"
                )
              p
                | Wenya Li
                br
                span
                  | Head of Ecselis/Havas
            li(
              @mouseover="activeIndex = 2"
              :class="{'active_li': activeIndex === 2}"
            )
              div
                img(
                  alt="avator"
                  src="@/assets/zoe.png"
                )
              p
                | Zoe
                br
                span
                  | Head of Performance/OMP

    contact
</template>

<script>
import MobileContact from '@/components/MobileContact'
export default {
  components: {
    Contact: MobileContact
  },
  data () {
    return {
      activeIndex: 0
    }
  },
  methods: {
    onApplyAccount () {
      this.$router.push('/contact?redirectUrl=/product/bid_agent&buttonName=申请Demo账号')
    }
  }
}
</script>
